import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../providers/AuthProvider'
import { usePermissions } from '../../hooks/usePermissions'

interface ProtectedRouteProps {
  children: React.ReactNode
  permission?: string
  adminOnly?: boolean
}

export function ProtectedRoute({ children, permission, adminOnly }: ProtectedRouteProps) {
  const location = useLocation()
  const { isAuthenticated, isLoading } = useAuth()
  const { hasPermission, isAdmin } = usePermissions()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Загрузка...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check admin-only routes
  if (adminOnly && !isAdmin()) {
    return <AccessDenied />
  }

  // Check permission-based routes
  if (permission && !isAdmin() && !hasPermission(permission, 'read')) {
    return <AccessDenied />
  }

  return <>{children}</>
}

function AccessDenied() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <div className="text-6xl mb-4">🔒</div>
        <h1 className="text-2xl font-bold text-gray-900 mb-2">Нет доступа</h1>
        <p className="text-gray-500 mb-6">У вас нет прав для просмотра этого раздела.</p>
        <a href="/" className="text-blue-600 hover:text-blue-800 font-medium">
          Вернуться на главную
        </a>
      </div>
    </div>
  )
}
